module.exports = __webpack_public_path__ + "2199cb521d25247918b8933543f1bc23.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/cutScale/fair.png
// module id = 844
// module chunks = 0